<template>
    <nav
        class="navbar navbar-expand-lg navbar-light"
        style="background-color: white"
    >
        <a
            class="navbar-brand d-lg-none"
            href="https://onegen01.com"
            target="_blank"
        >
            <img
                alt="Onegen 0,1"
                class="d-inline-block align-top"
                height="60"
                src="./../../images/logo-onegen01.jpg"
                width="auto"
            />
        </a>

        <button
            class="navbar-toggler"
            type="button"
            data-toggle="collapse"
            data-target="#navbarToggle"
            aria-controls="navbarToggle"
            aria-expanded="false"
            aria-label="Toggle navigation"
        >
            <span class="navbar-toggler-icon" />
        </button>

        <div
            class="collapse navbar-collapse justify-content-between"
            id="navbarToggle"
        >
            <a
                class="navbar-brand d-none d-lg-block"
                href="https://onegen01.com"
                target="_blank"
            >
                <img
                    alt="Onegen 0,1"
                    class="d-inline-block align-top"
                    height="60"
                    src="./../../images/logo-onegen01.jpg"
                    width="auto"
                />
            </a>

            <ul class="navbar-nav ml-auto">
                <li class="nav-item">
                    <a
                        class="nav-link"
                        href="https://www.onegen01.com/"
                        target="_blank"
                    >
                        <span
                            style="color: #000000;
                            font-family: Antic Slab;"
                        >
                            {{ $t("navbar.og01-home") }}
                        </span>
                    </a>
                </li>
                <li class="nav-item">
                    <a
                        class="nav-link"
                        href="https://www.onegen01.com/cosmetica-genomica/"
                        target="_blank"
                    >
                        <span
                            style="color: #000000;
                            font-family: Antic Slab;"
                        >
                            {{ $t("navbar.og01-cosmetogenomics") }}
                        </span>
                    </a>
                </li>
                <li class="nav-item">
                    <a
                        class="nav-link"
                        href="https://www.onegen01.com/one-gen-0-1/"
                        target="_blank"
                    >
                        <span
                            style="color: #000000;
                            font-family: Antic Slab;"
                        >
                            {{ $t("navbar.og01-onegen01") }}
                        </span>
                    </a>
                </li>
                <li class="nav-item">
                    <a
                        class="nav-link"
                        href="https://www.onegen01.com/genomic-center/"
                        target="_blank"
                    >
                        <span
                            style="color: #000000;
                            font-family: Antic Slab;"
                        >
                            {{ $t("navbar.og01-genomic-center") }}
                        </span>
                    </a>
                </li>
                <li class="nav-item">
                    <a
                        class="nav-link"
                        href="https://www.onegen01.com/contacto/"
                        target="_blank"
                    >
                        <span
                            style="color: #000000;
                            font-family: Antic Slab;"
                        >
                            {{ $t("navbar.og01-Contact") }}
                        </span>
                    </a>
                </li>
            </ul>

            <locale-switcher />
        </div>
    </nav>
</template>

<script>
import LocaleSwitcher from "./LocaleSwitcherOnegen01";

export default {
    computed: {
        currentLocale() {
            return this.$route.params.locale;
        }
    },
    components: {
        LocaleSwitcher
    }
};
</script>

<style scoped></style>
